import React from 'react'

import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { VerticalLinksType } from '@src/Application/Types/ComponentTypes'

import { Link, Title, TitleSection } from './VerticalLinks.styled'

export const VerticalLinks = (props: VerticalLinksType): JSX.Element => {
    const {
        title,
        subtitle,
        mode,
        linksDescription,
        column1name,
        column1links,
        column2name,
        column2links,
        column3name,
        column3links,
        column4name,
        column4links,
        column5name,
        column5links,
        column6name,
        column6links,
    } = props

    const columns = [
        { name: column1name, links: column1links },
        { name: column2name, links: column2links },
        { name: column3name, links: column3links },
        { name: column4name, links: column4links },
        { name: column5name, links: column5links },
        { name: column6name, links: column6links },
    ]

    return (
        <TitleSection title={title} subtitle={subtitle} mode={mode} description={linksDescription}>
            <Grid container>
                {columns.map(
                    (col, i) =>
                        col.name &&
                        col.links && (
                            <Grid item xs={12} md={2} key={`col-${i}`} spacingRight={3} spacingBottom={3}>
                                <Title>{col.name}</Title>
                                {col.links?.map((link, j) => (
                                    <Link to={link.url} key={`link-${i}-${j}`}>
                                        {link.label}
                                    </Link>
                                ))}
                            </Grid>
                        )
                )}
            </Grid>
        </TitleSection>
    )
}
